module.exports = __webpack_public_path__ + "img/12c1d6ecce7de58cf01a19cd966119d9.jpg";